import { render, staticRenderFns } from "./ProductWarranty.vue?vue&type=template&id=8e736708&"
import script from "./ProductWarranty.vue?vue&type=script&lang=js&"
export * from "./ProductWarranty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports